import { DEFAULT } from '../../../enum/analytics.enum';

export const getPageLoadTime = (): string => {
  const navigation = performance.getEntriesByType(
    'navigation'
  )[0] as PerformanceNavigationTiming;
  const loadTime = navigation
    ? (navigation.loadEventEnd - navigation.fetchStart) / 1000
    : 0;
  return loadTime.toFixed(2);
};

export const getLanguage = (): string => {
  const subdomain = window.location.hostname.split('.')[0];
  return subdomain.length === 2
    ? subdomain
    : document.documentElement.lang || navigator.language || DEFAULT.L;
};

export const getCountry = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  const tld = parts[parts.length - 1];
  return tld.length === 2 ? tld.toLowerCase() : DEFAULT.C;
};
